import React, { useEffect } from 'react'
import { useParams, useNavigate, generatePath } from 'react-router-dom'

import { API, Router } from 'app'
import { MediumContainer } from 'component/Layout'
import { BackCrumbs, useDataLoader } from 'component/Util'
import { ProblemsetView, DocumentView } from 'component/Course'

export const ResourcePage = () => {
    const params = useParams()
    const course_name = params.course_name
    const resIdx = parseInt(params.resIdx)
    const resourceLoader = useDataLoader()
    const navigate = useNavigate()

    useEffect(() => void resourceLoader.fetch(API.endpoints.RESOURCE_VIEW, { course_name, resIdx }), [])
    return resourceLoader.view(data => {
        var body
        if (data.resource.type == 'problemset') {
            body = <ProblemsetView contents={data.resource.contents} ></ProblemsetView>
        } else if (data.resource.type == 'document') {
            body = <DocumentView contents={data.resource.contents} ></DocumentView>
        } else {
            body = <>Error: invalid resource type for this view</>
        }
        return <MediumContainer>
            <BackCrumbs path={generatePath(Router.routes.COURSE_VIEW.path, { course_name })} msg='Back to course' />
            <h3>{data.course.title}</h3>
            <h4>{data.resource.title}</h4>
            {body}
        </MediumContainer>
    })
}
